import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import UserServices from '../../services/UserServices';
import PlanServices from '../../services/PlanServices';
import Pagetitle from '../../component/PageTitle';

function UserAdd() {
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    mobileNo: '',
    city: '',
    plan: '',
  });

  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');


  // Fetch states on component mount
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await PlanServices.getAllActivePlan();
        setPlans(response.data);
        // console.log(">>>",response.data)
      } catch (error) {
        console.error('Failed to fetch states', error);
      }
    };

    fetchPlans();
  }, []);


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        logo: file,
      });
    }
  };
  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  // Handle form submission
  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const formData = new FormData();
  //     for (const key in formValues) {
  //   if (key !== 'logo' || formValues[key] instanceof File) {
  //     formData.append(key, formValues[key]);
  //   } 
  //     }
  //     await UserServices.createUser(formValues);
  //     alert('user created successfully');
  //     navigate('/user-manager');
  //   } catch (error) {
  //     // alert('Failed to create user', error);
  //     alert(error.response?.data?.message || 'An error occurred while creating the user');
  //   }
  // };
  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      // Append all form values to the FormData object
      for (const key in formValues) {
        if (key === 'logo' && formValues[key] instanceof File) {
          formData.append(key, formValues[key]); // Append the logo file
        } else {
          formData.append(key, formValues[key]);
        }
      }

      // Call the createUser function with the FormData object
      await UserServices.createUser(formData);
      alert('User created successfully');
      navigate('/user-manager');
    } catch (error) {
      alert(error.response?.data?.message || 'An error occurred while creating the user');
    }
  };


  return (
    <div className="right_col" role="main">

      <Pagetitle></Pagetitle>

      <div className="container-box ">
        <div className="container-box-top-header justify-content-end">
          <div className="sub-title-box-right">
            <Link className="site-btn-green" to="/user-manager">User List</Link>
          </div>
        </div>
        <div className="container-box-inner px-4">
          <div className="row">
            <div className="col-md-12">
              <div className="page-details">
                <form onSubmit={handleSubmit}>
                  <div className='row'>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Name</label>
                        <input
                          type="text"
                          name="name"
                          value={formValues.name}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder='Enter Name'
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Mobile No.*</label>
                        <input
                          type="text"
                          name="mobileNo"
                          maxLength={10}
                          value={formValues.mobileNo}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder='Enter Mobile no'
                          required
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Email*</label>
                        <input
                          type="email"
                          name="email"
                          value={formValues.email}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder='Enter Email'
                          required
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>City*</label>
                        <input
                          type="text"
                          name="city"
                          value={formValues.city}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder='Enter City'
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Select Plan Name*</label>
                        <select
                          className="form-control"
                          name="plan"
                          value={formValues.state}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">--Select Plan Name--</option>
                          {plans.map((plan) => (
                            <option key={plan._id} value={plan._id}>
                              {plan.planName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Select Plan Type</label>
                    <select
                      className="form-control"
                      name="state"
                      value={formValues.state}
                      onChange={handleInputChange}
                    >
                      <option value="">--Select Plan Type--</option>
                      {states.map((state) => (
                        <option key={state._id} value={state._id}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  </div> */}

                    <div className="col-md-6">
                      <div className="input-field">
                        <label>Upload Logo<span className="red">*</span></label>
                        <input type="file" name="logo" className="form-control" onChange={handleFileChange} />
                        <div className="file-preview">
                          <img id="uploadFile" src={previewImage} alt="your logo" />

                        </div>
                      </div>
                    </div>
                  </div>
                  <button className="site-btn-green">SUBMIT</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserAdd;
